import React, { useState, useEffect, useRef } from 'react';
import { Form, Button, Alert, Spinner } from 'react-bootstrap';
import axios from 'axios';

import Constants from '../Constants';
import { useAuth } from '../AuthContext';
import '../App.css';

function FeedbackFormView() {
	const { token } = useAuth();

	const user_id = localStorage.getItem(Constants.USER_ID);

	const [issue_type, set_issue_type] = useState('bug');
	const [type_dropdown_open, set_type_dropdown_open] = useState(false);
	const type_dropdown_ref = useRef(null);

	useEffect(function() {
		const handle_click_outside = function(e) {
			if(type_dropdown_ref.current && !type_dropdown_ref.current.contains(e.target)) {
				set_type_dropdown_open(false);
			}
		};
		document.addEventListener('mousedown', handle_click_outside);
		return function() {
			document.removeEventListener('mousedown', handle_click_outside);
		};
	}, []);
	const [name, set_name] = useState('');
	const [description, set_description] = useState('');
	const [loading, set_loading] = useState(false);
	const [error, set_error] = useState('');
	const [success, set_success] = useState('');

	const handle_submit = async (event) => {
		event.preventDefault();
		set_error('');
		set_success('');

		if(!name.trim()) {
			set_error('Please enter a summary.');
			return;
		}
		if(!description.trim()) {
			set_error('Please enter a description.');
			return;
		}

		set_loading(true);
		try {
			const headers = token ? { Authorization: 'Bearer ' + token } : {};
			await axios.post(
				Constants.SERVER_URL + '/api/report_issue',
				{ type: issue_type, name, description },
				{ headers }
			);
			set_success('Thank you, your feedback has been submitted.');
			set_name('');
			set_description('');
			set_issue_type('bug');
		} catch (err) {
			set_error('Failed to submit feedback.');
		} finally {
			set_loading(false);
		}
	};

	return (
		<React.Fragment>
			<main className="admin-main">
				<h4 className="admin-title">Feedback & Bug Reports</h4>
				<p className="feedback-form-subtitle">Let us know what you like, what needs fixing, or what could be improved.</p>

				{error ? <Alert variant="danger">{error}</Alert> : null}
				{success ? <Alert variant="success">{success}</Alert> : null}

				<Form onSubmit={handle_submit} className="admin-form-panel feedback-form">

					<Form.Group className="admin-form-group">
						<Form.Label className="form-input-label">Type</Form.Label>
						<div className="voice-dropdown" ref={type_dropdown_ref}>
							<div
								className="voice-dropdown-trigger"
								onClick={function() { set_type_dropdown_open(function(prev) { return !prev; }); }}>
								<span>{issue_type === 'bug' ? 'Bug' : 'Feedback'}</span>
								<span className="voice-dropdown-arrow">&#9660;</span>
							</div>
							{type_dropdown_open && (
								<div className="voice-dropdown-list">
									<div
										className={'voice-dropdown-option' + (issue_type === 'bug' ? ' voice-dropdown-option-selected' : '')}
										onClick={function() { set_issue_type('bug'); set_type_dropdown_open(false); }}>
										Bug
									</div>
									<div
										className={'voice-dropdown-option' + (issue_type === 'feedback' ? ' voice-dropdown-option-selected' : '')}
										onClick={function() { set_issue_type('feedback'); set_type_dropdown_open(false); }}>
										Feedback
									</div>
								</div>
							)}
						</div>
					</Form.Group>

					<Form.Group className="admin-form-group">
						<Form.Label className="form-input-label">Summary</Form.Label>
						<Form.Control
							type="text"
							value={name}
							onChange={function(e) { set_name(e.target.value); }}
							placeholder="Short summary"
							className="admin-form-control"
							required
						/>
					</Form.Group>

					<Form.Group className="admin-form-group">
						<Form.Label className="form-input-label">Description</Form.Label>
						<Form.Control
							as="textarea"
							rows={5}
							value={description}
							onChange={function(e) { set_description(e.target.value); }}
							placeholder="Describe the issue or suggestion"
							className="admin-form-control"
							required
						/>
					</Form.Group>

					<div className="admin-form-actions">
						<Button variant="primary" type="submit" disabled={loading}>
							{loading ? <Spinner animation="border" size="sm" /> : 'Submit'}
						</Button>
					</div>

				</Form>
			</main>
		</React.Fragment>
	);
}

export default FeedbackFormView;
